import type { ReactNode } from 'react';

export function UniLoginLayout({ children, actions }: { children?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="flex h-56 flex-col gap-4">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center">{children}</div>
      {actions && <div className="flex shrink-0 flex-col gap-2 [&>button]:mt-0">{actions}</div>}
    </div>
  );
}
